import React from "react"
import styled from "styled-components"

import { Section, Container } from "../global"

const Features = () => (
  <Section id="caracteristicas">
    <StyledContainer>
      <Subtitle>Caracteristicas</Subtitle>
      <SectionTitle>Pequeños cambios, gran impacto</SectionTitle>
      <FeaturesGrid>
        <FeatureItem>
          <FeatureTitle>Lugares</FeatureTitle>
          <FeatureText>
            Descubre retos y lugares desde donde puede generar cambio.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Arenas</FeatureTitle>
          <FeatureText>
            Alcanza las multiples arenas, a medida que completes retos.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Trofeos</FeatureTitle>
          <FeatureText>Sube a la cima de Ecolote</FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Historial</FeatureTitle>
          <FeatureText>
            Lleva un registro de los retos que has completado
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Comunidad</FeatureTitle>
          <FeatureText>
            Ayuda a generar impacto con solo integrarte a la comunidad y
            generando nuevas ideas.
          </FeatureText>
        </FeatureItem>
        <FeatureItem>
          <FeatureTitle>Diviertete</FeatureTitle>
          <FeatureText>
            Aprende nuevas cosas, a medida que finalices los retos
          </FeatureText>
        </FeatureItem>
      </FeaturesGrid>
    </StyledContainer>
  </Section>
)

export default Features

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${props => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 40px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${props => props.theme.color.accent};
  letter-spacing: 0px;
  margin-bottom: 12px;
  text-align: center;
`

const FeaturesGrid = styled.div`
  max-width: 670px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0px auto;
  grid-column-gap: 40px;
  grid-row-gap: 35px;
  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 64px;
  }
`

const FeatureItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const FeatureTitle = styled.h4`
  color: ${props => props.theme.color.primary};
  letter-spacing: 0px;
  line-height: 30px;
  margin-bottom: 10px;
`

const FeatureText = styled.p`
  text-align: center;
`
